export default {
  form: {
    payment_type: null,
    code: '',
    member_name: '',
    member_id: '',
    details: { member_name: null, member_id: null },
  },
  voucher: null,
  total: null,
  discount: null,
  errors: { member_name: null, member_id: null, code: null },
}
